import { fileUrl } from "@/lib/api";
import { Film } from "lucide-react";

export const MediaThumb = ({ item, testid }) => {
  const url = fileUrl(item.file_id);
  const isVideo = item.content_type?.startsWith("video/");
  return (
    <a href={url} target="_blank" rel="noreferrer" data-testid={testid}
      className="group relative block aspect-square overflow-hidden rounded-xl border bg-slate-100">
      {isVideo ? (
        <>
          <video src={url} className="h-full w-full object-cover" muted preload="metadata" />
          <Film className="absolute left-2 top-2 h-5 w-5 text-white drop-shadow" />
        </>
      ) : (
        <img src={url} alt={item.name} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
      )}
    </a>
  );
};

export const MediaGrid = ({ items = [], prefix = "media" }) =>
  items.length ? (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
      {items.map((m, i) => (
        <MediaThumb key={m.file_id} item={m} testid={`${prefix}-item-${i}`} />
      ))}
    </div>
  ) : (
    <p className="text-sm text-slate-500" data-testid={`${prefix}-empty`}>Nessun file caricato.</p>
  );
